// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disabled[data-v-3ddbd333]{opacity:.6!important;pointer-events:none!important}.img-preview[data-v-3ddbd333]{max-height:200px!important;max-width:100%!important}", "",{"version":3,"sources":["webpack://./chat/vue/widget/form/ChatUpload.vue"],"names":[],"mappings":"AACA,2BAEI,oBAAA,CADA,6BACA,CAGJ,8BAEE,0BAAA,CADA,wBACA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
